// @ts-strict-ignore
import { useEffect, useRef } from 'react';

import { trackOutboundLinks } from 'lib/analytics/mixpanel-helpers';

import Icon from 'components/@tedui/Icon';
import { BaseButtonType, IconPositionType } from 'components/base-button';
import LinkButton from 'components/link-button';
import Markdown from 'components/markdown';
import { Text } from 'components/typography';

import useVideoPlayerStore from 'components/video-player/store';
import type TakeActionCardProps from './TakeActionCard.props';

const TakeActionCard = ({ blurb, verb, linkUrl }: TakeActionCardProps) => {
  const linkRef = useRef(undefined);
  const autoplayed = useVideoPlayerStore(store => store.autoplayed);
  useEffect(() => {
    trackOutboundLinks(linkRef.current, 'talk cta', linkUrl, autoplayed);
  }, []);

  return (
    <>
      <div className="mb-5 md:mb-0 md:max-w-lg">
        <Text size="l" className="text-gray-500">
          <Markdown>{blurb}</Markdown>
        </Text>
      </div>
      <div className="flex grow md:ml-2 md:justify-end">
        <LinkButton
          className="whitespace-nowrap capitalize"
          href={linkUrl}
          icon={() => <Icon iconName="arrow-right-long" />}
          iconPosition={IconPositionType.Trailing}
          text={verb.replace(/_/g, ' ')}
          variant={BaseButtonType.Primary}
          rel="noopener noreferrer"
          target="_blank"
          ref={linkRef}
        />
      </div>
    </>
  );
};

export default TakeActionCard;
